import { array, string, struct } from 'io-ts/Decoder';

export const Request = struct({
	emojis: array(string),
});
